import { StoreAction, XmAction } from 'store/actions';
import { LineBannerInfo } from './models';

export function lineBannerReducer(state: LineBannerInfo[] = [], action: XmAction<LineBannerInfo>): LineBannerInfo[] {
    let newState: LineBannerInfo[];
    switch (action.type) {
        case StoreAction.GET_LINE_BANNER_INFO:
            // delete old banner if present
            newState = state.filter((item: LineBannerInfo) => item.lineId !== action.payload.lineId);

            return [ ...newState, action.payload ];
        case StoreAction.CLEAR_LINE_BANNER_INFO:
            // if no filter then clear all
            if (!action.filters) {
                return undefined;
            }

            newState = state.filter((item: LineBannerInfo) => item.lineId !== action.filters.lineId);

            return [ ...newState, action.payload ];
        default:
            return state;
    }
}
